export enum Auth {
    Token = 'token',
    FirstName = 'firstName',
    LastName = 'lastName',
    Role = 'role',
    Id = 'Id',
    Email = 'Email'
}


export type StorageKey = Auth;
